import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auth, createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword, signOut } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';
import { User } from '../../models/User';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  constructor(private auth: Auth,
              private http: HttpClient) {}

  navVisibility: boolean = false;
  user: User = {id: '', email: '', role: ''}
  token: string = ''
  authHeader = new HttpHeaders({
    'Authorization': 'Bearer ' + this.token,
  });

  register({email, password}: any){
    return createUserWithEmailAndPassword(this.auth, email, password);
  }

  login({email, password}: any){
    return signInWithEmailAndPassword(this.auth, email, password)
  }

  logout(){
    return signOut(this.auth);
  }

  sendEmailResetPassword(email: string){
    sendPasswordResetEmail(this.auth, email)
      .then(() => {
        console.log('Correo electrónico de restablecimiento de contraseña enviado correctamente.');
      })
      .catch((error) => {
        console.error('Error al enviar el correo electrónico de restablecimiento de contraseña:', error);
      }
    );
  }

  verifyUser(): Promise<string>{
    return new Promise<string>((resolve, reject) => {
      this.auth.onAuthStateChanged((user) => {
        if(user){
          user.getIdToken().then((idToken) => {
            this.token = idToken
            this.authHeader = new HttpHeaders({
              'Authorization': 'Bearer ' + this.token,
            });
            if(this.auth.currentUser) this.user.email = this.auth.currentUser.email!!
            if(this.user.email){
              resolve(idToken)
              this.getMyselfUser().subscribe(
                user => {
                  if(user){
                    this.user = user
                    console.log("Usuario actual", this.user)
                    resolve(idToken)
                  }
                },
                error => {
                  reject('Error al obtener el usuario: ' + error.message.toString())
                }
              )
            }
            else(reject('No se ha encontrado un usuario.'))
          })
          .catch((error) => {
            reject(error)
          });      
        }
        else {
          reject('Usuario no autenticado')
        }
      })
    })
  }

  isAuth(): Promise<boolean>{
    return new Promise((resolve) => {
      console.log("Usuario actual", this.auth.currentUser)
      if(this.auth.currentUser){
        this.auth.currentUser.getIdToken(true).then(idToken => {
          console.log("Token del usuario", idToken)
          if(this.auth.currentUser) this.user.email = this.auth.currentUser.email!!
          if(idToken) resolve(true)
          else resolve(false)
        }).catch(error => {
          console.error("Error al obtener la sesión del usuario", error)
          resolve(false)
        })
      }
      else{
        console.error("Usuario no logueado");
        resolve(false);
      }
    });
  }
  verifyNavVisibility(){
    this.auth.onAuthStateChanged((user) => {
      if (user) {
        this.user.email = user.email!!.split('@')!![0]
        user.getIdToken()
          .then((idToken) => {
            this.token = idToken
            this.authHeader = new HttpHeaders({
              'Authorization': 'Bearer ' + this.token,
            });
            // if(user.email) this.createLog(user.email).subscribe(
            //   log => console.log("Created log", log)
            // )
            this.navVisibility = true;
          })
          .catch();
      }});
  }

  manageFirebaseError(firebase_error: string){
    switch(firebase_error){
      case 'Firebase: Error (auth/invalid-email).':
        return 'Usuario desconocido.'
      case 'Firebase: Error (auth/user-not-found).':
        return 'Usuario desconocido.'
      case 'Firebase: Error (auth/missing-password).':
        return 'Introduzca una contraseña.'
      case 'Firebase: Error (auth/wrong-password).':
        return 'Contraseña incorrecta.'
      case 'Firebase: Error (auth/invalid-credential).':
        return 'Credenciales incorrectos.'
      case 'Firebase: Error (auth/too-many-requests).':
        return 'Demasiados intentos, inténtalo más tarde o prueba a restablecer tu contraseña.'
      case 'Firebase: Error (auth/email-already-in-use).':
        return 'Ya existe una cuenta asociada a este correo.'
      default: 
        return 'Ha ocurrido un error.'
    }
  }

  getMyselfUser(){
    return this.http.get<User>(`${environment.URL_API}/api/users/myself`, {headers: this.authHeader})
  }
}
